// Ajustador global de tamaño (pensado para usuarios mayores).
// OJO: NO usa font-size de la raíz — las páginas del panel definen sus
// tamaños en px inline (fontSize: 13), que no siguen a rem, así que aquello
// no escalaba nada. `zoom` en el <body> escala TODO proporcionalmente:
// texto, botones y espacios. Soportado por Chrome/Edge/Safari y Firefox 126+.

const KEY = 'fontScale';

export const FONT_MIN = 80;
export const FONT_MAX = 140;
export const FONT_STEP = 10;
export const FONT_DEFAULT = 100;

const clamp = (n: number) =>
  Math.min(FONT_MAX, Math.max(FONT_MIN, Math.round(n / FONT_STEP) * FONT_STEP));

export function getFontScale(): number {
  const v = parseInt(localStorage.getItem(KEY) || '', 10);
  return Number.isFinite(v) ? clamp(v) : FONT_DEFAULT;
}

export function applyFontScale(scale: number = getFontScale()): void {
  (document.body.style as any).zoom = `${scale}%`;
  // Con zoom en el body, Chrome también escala `vh`: 100vh deja de llenar la
  // ventana. --vh100 compensa; usarla en vez de 100vh para alturas de pantalla.
  document.body.style.setProperty('--vh100', `${10000 / scale}vh`);
}

export function setFontScale(scale: number): number {
  const c = clamp(scale);
  localStorage.setItem(KEY, String(c));
  applyFontScale(c);
  return c;
}
